export default {
	actualities: 'Actualities',
	backHome: 'Return to actualities',
	buttons: {
		editAlert: 'Show or edit an alert',
		editBirthday: 'Add or edit a birthday',
		eventParticipate: 'Participate',
		newActuality: 'Publish an actuality',
		newEvent: 'Create an event',
		newNotice: 'Create a notice'
	},
	consult: 'Consult',
	consultEventsBtn: 'See all events',
	consultNoticesBtn: 'See all notices',
	credits: 'Ordre des dentistes du Québec. All rights reserved.',
	categories: 'Documents and resources',
	errors: {
		server: {
			init: 'The connection to the server could not be completed.',
		},
	},
	events: 'Events',
	eventSeparator: 'Past events',
	homeWelcome: 'Welcome to',
	leaveEmpty: 'Leave empty',
	less: '... less',
	login: {
		title: 'Welcome on Dentaclic, the Ordre des dentistes du Québec\'s intranet',
		description: 'Consult the Ordre\'s news and actualities, emplore the events to come and easily access resources, documents and other tools.',
		instruction: 'Connect directly with your ODQ email adress. No need to subscribe.',
		codeInstruction: 'Enter the 6 digits code sent to',
		emailPlaceholder: 'Example : surname.name',
		newCodeSent: 'A new login code has been sent to your email address.',
		noCodeLink: 're-send the code',
		noCodeMessage: 'Can\'t find your code? Check in your spam folder or',
		submit: 'Submit'
	},
	more: '... more',
	nextEvents: 'Next events',
	newNotices: 'Latest posts on the notice board',
	noCategory: 'No sub category has been added to this category yet.',
	noDoc: 'No documents have been added to this category yet.',
	noFilteredEvents: 'Unfortunately, no events were found matching your search criterias.',
	noFilteredNotices: 'Unfortunately, no notices were found matching your search criterias.',
	notFound: 'Page not found',
	notices: 'Notice board',
	noticesFilterNew: 'New notices since my last visit',
	noticesFilterMine: 'Show my notices only',
	noticesFiltersTitle: 'Filters',
	noticesSinceVisit: 'new notices since your last visit',
	notification: {
		beenDeleted: 'has been deleted by an admin because',
		yourNotice: 'Your notice',
	},
	popup: {
		copiedText: 'The sharing link has been copied to your clipboard.',
		createdElement: 'has successfully been created.',
		deletedElement: 'has successfully been deleted.',
		modifiedElement: 'has successfully been modified.',
		theAlert: 'The alert',
		theEmployee: 'The employee',
		theRapidLinks: 'The section actions and rapid links',
	},
	rapidLinksTitle: 'Actions and rapid links',
	weekDays: {
		sunday: 'S',
		monday: 'M',
		tuesday: 'T',
		wednesday: 'W',
		thursday: 'T',
		friday: 'F',
		saturday: 'S',
	}
}
